<ng-container *transloco="let t; read: 'user'">
<drdp-dashboard-search [displayDropdowns]="displayDropdowns" [requiredFields]="requiredFields"
  [title]="t('stateDashboard.export.programsTitle')" (exportClicked)="handleSearch($event)" [distinctPrograms]="true">
</drdp-dashboard-search>
</ng-container>